<template>
  <grid-layout
    style="height: 100%; width: 100%"
    :layout.sync="layout"
    :auto-size="false"
    :responsive="true"
    :col-num="30"
  >
    <MglMap
      v-if="multiColor"
      ref="map"
      :access-token="accessToken"
      :map-style="style"
      @load="mapLoaded()"
    >
      <MglFullscreenControl position="top-right" />
      <MglNavigationControl position="top-right" />
      <MglGeolocateControl position="top-right" />
      <MglMarker
        v-for="(point, index) in voyage"
        :key="`voyage-${index}`"
        :coordinates="point.coords"
        @mouseenter="showMarkerPopUp(point)"
        @mouseleave="hideMarkerPopUp()"
      >
        <div slot="marker">
          <v-icon
            v-if="point.dir == 'top'"
            slot="marker"
            size="15"
            :color="point.color"
          >
            mdi-arrow-up
          </v-icon>
          <v-icon
            v-if="point.dir == 'top-right'"
            slot="marker"
            size="15"
            :color="point.color"
          >
            mdi-arrow-top-right
          </v-icon>
          <v-icon
            v-if="point.dir == 'right'"
            slot="marker"
            size="15"
            :color="point.color"
          >
            mdi-arrow-right
          </v-icon>
          <v-icon
            v-if="point.dir == 'bottom-right'"
            slot="marker"
            size="15"
            :color="point.color"
          >
            mdi-arrow-bottom-right
          </v-icon>
          <v-icon
            v-if="point.dir == 'bottom'"
            slot="marker"
            size="15"
            :color="point.color"
          >
            mdi-arrow-down
          </v-icon>
          <v-icon
            v-if="point.dir == 'bottom-left'"
            slot="marker"
            size="15"
            :color="point.color"
          >
            mdi-arrow-bottom-left
          </v-icon>
          <v-icon
            v-if="point.dir == 'left'"
            slot="marker"
            size="15"
            :color="point.color"
          >
            mdi-arrow-left
          </v-icon>
          <v-icon
            v-if="point.dir == 'top-left'"
            slot="marker"
            size="15"
            :color="point.color"
          >
            mdi-arrow-top-left
          </v-icon>
        </div>
      </MglMarker>
      <MglMarker
        v-for="(st, index) in start"
        :key="`start-${index}`"
        :coordinates="st.coordinates"
      >
        <v-btn
          slot="marker"
          fab
          x-small
          :color="st.color"
        >
          <v-icon color="#FFFFFF">
            mdi-anchor
          </v-icon>
        </v-btn>
      </MglMarker>
      <MglMarker
        v-for="vessel in vessels"
        :key="vessel.idVessel"
        :coordinates="vessel.coordinates"
      >
        <v-col slot="marker">
          <v-row>
            <v-btn
              fab
              x-small
              :color="vessel['color']"
              class="ma-auto"
              @click="vesselIconClick(vessel.Vessel)"
            >
              <v-icon color="#FFFFFF">
                mdi-ferry
              </v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <div class="mapTitle ma-auto">
              {{ vessel.Vessel }}
            </div>
          </v-row>
        </v-col>
      </MglMarker>
      <MglMarker
        v-if="currentVesselPosition"
        :coordinates="currentVesselPosition"
      >
        <v-col slot="marker">
          <v-row>
            <v-btn
              fab
              x-small
              color="light-green"
              class="ma-auto"
            >
              <v-icon color="#FFFFFF">
                mdi-ferry
              </v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <div class="mapTitle ma-auto">
              Live Vessel Position
            </div>
          </v-row>
        </v-col>
      </MglMarker>
    </MglMap>
    <MglMap
      v-else
      ref="map"
      :access-token="accessToken"
      :map-style="style"
      @load="mapLoaded()"
    >
      <v-menu
        offset-y
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :flat="true"
            color="primary"
            class="mt-2 ml-2"
            v-bind="attrs"
            @click="click"
            v-on="on"
          >
            <v-icon dark>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-checkbox
              label="Show ECA"
              :value="displayEca"
              class="ma-0 pa-0"
              :ripple="false"
              dense
              @click="toggleDisplayEcas"
            />
          </v-list-item>
          <v-list-item>
            <v-checkbox
              label="Show Piracy"
              :value="displayPiracy"
              :ripple="false"
              class="mt-1 pa-0"
              dense
              @click="toggleDisplayPiracy"
            />
          </v-list-item>
          <v-list-item>
            <v-checkbox
              v-model="showFouling"
              label="Show fouling condition"
              :ripple="false"
              class="mt-1 pa-0"
              dense
            />
          </v-list-item>
        </v-list>
      </v-menu>
      <MglFullscreenControl position="top-right" />
      <MglNavigationControl position="top-right" />
      <MglGeolocateControl position="top-right" />
      <MglMarker
        v-for="vessel in vessels"
        :key="vessel.idVessel"
        :coordinates="vessel.coordinates"
      >
        <v-col slot="marker">
          <v-row>
            <v-btn
              fab
              x-small
              :color="vessel[`${vesselIconColor}`]"
              class="ma-auto"
              @click="vesselIconClick(vessel)"
            >
              <v-icon color="#FFFFFF">
                mdi-ferry
              </v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <div class="mapTitle ma-auto">
              {{ vessel.Vessel }}
            </div>
          </v-row>
        </v-col>
      </MglMarker>
      <Ecas />
    </MglMap>
  </grid-layout>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Mapbox from "mapbox-gl";
import {
  MglMap,
  MglNavigationControl,
  MglGeolocateControl,
  MglMarker,
  MglFullscreenControl,
} from "vue-mapbox";
import Ecas from "../views/weather_routing/map/layers/ecas.vue";

export default {
  name: "Map",
  components: {
    MglMap,
    MglNavigationControl,
    MglGeolocateControl,
    MglMarker,
    MglFullscreenControl,
    Ecas,
  },
  props: ["vessels", "voyage", "multiColor", "start", "showLayers"],
  data: function () {
    return {
      style: process.env.VUE_APP_MAPBOX_STYLE,
      tilesDate: "2019-11-18",
      coordinates: [-111.549668, 39.014],
      accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      layout: [],
      maplLoaded: false,
      showFouling: false,
    };
  },
  methods: {
    ...mapActions("weatherRouting/areasModule", [
      "toggleDisplayEcas",
      "toggleDisplayPiracy",
    ]),
    ...mapActions(["setCurrentVesselName", "setSideBar"]),
    vesselIconClick(vessel) {
      this.setCurrentVesselName(vessel.Vessel);
      this.setSideBar(true);
      this.$store.commit("main/SET_SELECTED_VESSEL", vessel);
    },
    showMarkerPopUp(marker) {
      if (marker.html) {
        const popup = new Mapbox.Popup({
          maxWidth: "500px",
          anchor: "top",
          closeButton: true,
          closeOnClick: false,
          className: "custom-popup",
          offset: 25,
        });

        popup
          .setLngLat(marker.coords)
          .setHTML(`<div class="vessel-popup-content">${marker.html}</div>`)
          .addTo(this.$refs["map"].map);

        this.$refs["markerPopup"] = popup;
      }
    },
    hideMarkerPopUp() {
      if (this.$refs["markerPopup"]) this.$refs["markerPopup"].remove();
    },
    fixMapSize() {
      this.$refs.map.map.resize();
    },
    mapLoaded() {
      this.maplLoaded = true;

      if (this.vessels.length > 0) this.setBounds();
    },
    setBounds() {

      let coordForbounds = [];

      for (let v = 0; v < this.vessels.length; v++) {
        if (this.vessels[v].coordinates)
          coordForbounds.push(this.vessels[v].coordinates);
      }

      if (this.voyage && this.multiColor) {
        coordForbounds = coordForbounds.concat(
          this.voyage.map((item) => item.coords)
        );
      } else if (this.voyage) {
        coordForbounds = coordForbounds.concat(this.voyage);
      }

      // remove invalid coordinates
      coordForbounds = coordForbounds.filter((coord) =>
        Array.isArray(coord) &&
    coord.length === 2 &&
    !isNaN(coord[0]) &&
    !isNaN(coord[1]) &&
    Math.abs(coord[0]) <= 180 &&
    Math.abs(coord[1]) <= 90
      );

      if (!coordForbounds.length) return;

      const bounds = new this.mapbox.LngLatBounds();

      coordForbounds.forEach((coord) => bounds.extend(coord));

      this.$refs["map"].map.fitBounds(bounds, {
        padding: 40,
        maxZoom: 6
      });
    },
    convertCoords(input) {
      const parts = input.match(/\d+/g).map(Number);
      const dir = input.match(/[a-zA-Z]/);

      let coord = parts[0] + parts[1] / 60 + parts[2] / (60 * 60);

      if (dir == "S" || dir == "W") {
        coord = coord * -1;
      }
      return coord;
    },
  },
  computed: {
    ...mapState("weatherRouting/areasModule", ["displayEca", "displayPiracy"]),
    ...mapGetters(["getVesselsData"]),
    vesselIconColor() {
      return this.showFouling ? "foulColor" : "color";
    },
    currentVesselPosition() {
      const currentVessel = this.$route.params.vessel;

      if (!Array.isArray(this.getVesselsData)) {
        return null;
      }

      const vessel = this.getVesselsData.find(function (item) {
        return item && item.Vessel == currentVessel;
      });

      if (!vessel || !Array.isArray(vessel.coordinates)) {
        return null;
      }

      return vessel.coordinates;
    },
  },
  watch: {
    // '$route.params': {
    //   handler: function() {

    //     if (this.$route.params.vessel) {
    //       this.layout = [];
    //     }
    //     else{
    //       this.layout = [{"x":0,"y":0,"w":2,"h":1,"i":"0"},{"x":2,"y":0,"w":2,"h":1,"i":"1"}];
    //     }

    //   },
    //   deep: true,
    //   immediate: true
    // },
    vessels: {
      handler: function () {
        if (this.maplLoaded) this.setBounds();
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    this.mapbox = Mapbox;
  },
};
</script>

<style scoped>
.map-style {
  border: 2px solid lightblue;
}

.custom-popup {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 0;
}

.custom-popup .mapboxgl-popup-content {
  padding: 15px;
  border-radius: 8px;
}

.custom-popup .mapboxgl-popup-close-button {
  font-size: 20px;
  color: #666;
  padding: 5px 10px;
  right: 0;
  top: 0;
}

.custom-popup .mapboxgl-popup-close-button:hover {
  background-color: transparent;
  color: #000;
}

.vessel-popup-content {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  line-height: 1.5;
  color: #333;
}

.popup-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.popup-item:last-child {
  border-bottom: none;
}

.popup-item i {
  font-size: 20px;
  color: #1976d2;
  margin-right: 12px;
  width: 24px;
  text-align: center;
}

.popup-item-content {
  display: flex;
  flex-direction: column;
}

.popup-label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.popup-value {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-top: 2px;
}

.custom-popup .mapboxgl-popup-tip {
  border-top-color: rgba(255, 255, 255, 0.95);
}
</style>
